var map = {
	"./clinic-management-blue.png": "./src/assets/services/clinic-management-blue.png",
	"./clinic-management-white.png": "./src/assets/services/clinic-management-white.png",
	"./doc-app-blue.png": "./src/assets/services/doc-app-blue.png",
	"./doc-app-white.png": "./src/assets/services/doc-app-white.png",
	"./equipment-blue.png": "./src/assets/services/equipment-blue.png",
	"./equipment-white.png": "./src/assets/services/equipment-white.png",
	"./hemo-blue.png": "./src/assets/services/hemo-blue.png",
	"./hemo-white.png": "./src/assets/services/hemo-white.png",
	"./irannoskhe-blue.png": "./src/assets/services/irannoskhe-blue.png",
	"./irannoskhe-white.png": "./src/assets/services/irannoskhe-white.png",
	"./kiosk-blue.png": "./src/assets/services/kiosk-blue.png",
	"./kiosk-white.png": "./src/assets/services/kiosk-white.png",
	"./ostad-time-blue.png": "./src/assets/services/ostad-time-blue.png",
	"./ostad-time-white.png": "./src/assets/services/ostad-time-white.png",
	"./patient-app-blue.png": "./src/assets/services/patient-app-blue.png",
	"./patient-app-white.png": "./src/assets/services/patient-app-white.png",
	"./phone-app-blue.png": "./src/assets/services/phone-app-blue.png",
	"./phone-app-white.png": "./src/assets/services/phone-app-white.png",
	"./site-blue.png": "./src/assets/services/site-blue.png",
	"./site-create-blue.png": "./src/assets/services/site-create-blue.png",
	"./site-create-white.png": "./src/assets/services/site-create-white.png",
	"./site-white.png": "./src/assets/services/site-white.png",
	"./ussd-blue.png": "./src/assets/services/ussd-blue.png",
	"./ussd-white.png": "./src/assets/services/ussd-white.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/services sync \\.(png%7Cjpe?g)$";